import layoutBlocks from "../partials/layout-blocks";
import configPage from "../partials/config-page";
import seo from '../partials/seo';


function page (lang) {
    return {
        file: `site/content/_index.${lang}.md`,
        label: `Home Page ${lang}`,
        name: `home_${lang}`,
        ...configPage,
        fields: [
            {label: 'Title', name: 'title', widget: 'string', i18n: true},
            {label: 'Hero header title', name: 'hero_title', widget: 'markdown', i18n: true},
            {label: 'Hero header Body', name: 'hero_body', widget: 'markdown', required: false, i18n: true},
            {label: 'Hero header Image', name: 'hero_img', widget: 'image', required: false, i18n: true},
            {label: 'Hero link label', name: 'hero_link_label', widget: 'string', required: false, i18n: true},
            {
                label: "Header Link",
                name: "hero_collection",
                widget: "relation",
                multiple: false,
                required: false,
                collection: "pages",
                search_fields: ["title", "slug"],
                value_field: "{{slug}}",
                display_fields: ["title"],
                i18n: true
            },
            {
                label: "Featured Image",
                name: "featured_image",
                widget: "object",
                collapsed: true,
                fields: [
                     {label: "Video active", name: "active", widget: "boolean", default: false},
                     {name: "id", label: "Video", widget: "string", required: false},
                    {
                        name: 'src',
                        label: 'Image',
                        widget: 'image',
                        media_folder: "/site/assets/images/headers/",
                        public_folder: "/images/headers/"
                    }
                ]
            },
            layoutBlocks(),
            ...seo
        ]
    }
}

export default page
